import { render, staticRenderFns } from "./AMRealOpenGhost.vue?vue&type=template&id=c25329ac"
import script from "./AMRealOpenGhost.vue?vue&type=script&lang=ts"
export * from "./AMRealOpenGhost.vue?vue&type=script&lang=ts"
import style0 from "../assets/styles/pages/AMRealOpenGhost.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports